import axios from "axios"
import config from '../../config/client.json'

export const api = axios.create({
    baseURL: config.serviceUrl
    //baseURL: "https://cbs.manisasu.gov.tr/proje.services",
    //baseURL: "https://cbs.rizeozelidare.gov.tr/proje.services",
    //baseURL: "https://localhost:10023"
})

// defining a custom error handler for all APIs
const errorHandler = (error) => {
    const statusCode = error.response?.status

    if (error.code === "ERR_CANCELED") {
        /*notification.error({
            placement: "bottomRight",
            description: "İstek iptal edildi!",
        })*/
        return Promise.resolve()
    }

    // logging only errors that are not 401
    if (statusCode && statusCode !== 401) {
        console.error(error)
    }

    return Promise.reject(error)
}

// registering the custom error handler to the
// "api" axios instance
api.interceptors.response.use(undefined, (error) => {
    return errorHandler(error)
})